export default __webpack_public_path__ + "static/media/aldinhalilovic.7db7f980.pdf";